export default "__VITE_ASSET__BE_nLPS0__"